import { ShieldCheck, MapPinned, Users, ArrowRight } from "lucide-react";
import { LeadForm } from "@/components/landing/LeadForm";
import { openEnquiry } from "@/lib/api";
import { IMAGES } from "@/data/siteData";

const TRUST = [
    { icon: ShieldCheck, text: "Trusted Trip Planning" },
    { icon: Users, text: "End-to-End Execution" },
    { icon: MapPinned, text: "Pan India Experiences" },
];

export function Hero() {
    return (
        <section id="top" className="relative bg-cream overflow-hidden" data-testid="hero-section">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-12 pb-16 lg:pt-16">
                <div className="grid lg:grid-cols-[1.15fr_0.85fr] gap-10 items-start">
                    <div>
                        <p className="font-script text-4xl sm:text-5xl text-saffron -rotate-2 inline-block" data-testid="hero-tagline-script">
                            Har Safar, Ek Kahani
                        </p>
                        <h1 className="mt-3 font-display font-black tracking-tight leading-[0.98] text-4xl sm:text-6xl lg:text-7xl text-navy" data-testid="hero-headline">
                            SIRF TRIP NAHI.
                            <br />
                            <span className="text-saffron">YAADEIN BANANE CHALE.</span>
                        </h1>
                        <p className="mt-6 text-base sm:text-lg text-stone-600 max-w-xl leading-relaxed" data-testid="hero-subtext">
                            School trips, college tours, industrial visits, corporate outings and group adventures —
                            planned, managed and executed end-to-end by GhumneChaley.com.
                        </p>
                        <div className="mt-8 flex flex-wrap items-center gap-4">
                            <button
                                onClick={() => openEnquiry()}
                                data-testid="hero-plan-my-trip-btn"
                                className="inline-flex items-center gap-2 px-8 py-4 rounded-full text-sm font-display font-black uppercase tracking-wider text-white bg-saffron hover:bg-saffron-dark transition-all hover:-translate-y-0.5"
                            >
                                Plan My Trip <ArrowRight className="h-4 w-4" />
                            </button>
                            <a
                                href="#destinations"
                                data-testid="hero-explore-btn"
                                className="inline-flex items-center gap-2 px-8 py-4 rounded-full text-sm font-display font-black uppercase tracking-wider text-navy border-2 border-navy hover:bg-navy hover:text-white transition-all"
                            >
                                Explore Experiences
                            </a>
                        </div>
                        <div className="mt-8 flex flex-wrap gap-x-6 gap-y-2" data-testid="hero-trust-line">
                            {TRUST.map((t) => (
                                <span key={t.text} className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-wider text-stone-500">
                                    <t.icon className="h-4 w-4 text-saffron" /> {t.text}
                                </span>
                            ))}
                        </div>
                    </div>

                    <div className="hidden lg:block">
                        <div className="bg-white rounded-2xl border border-stone-300 p-6 shadow-[8px_8px_0_0_#1B3A66]" data-testid="hero-enquiry-card">
                            <h2 className="font-display font-black text-xl text-navy">Planning a Trip?</h2>
                            <p className="text-xs text-stone-500 mt-1 mb-4">Tell us the basics — get a custom trip plan within 24 hours.</p>
                            <LeadForm idPrefix="hero" source="hero-card" buttonLabel="Get My Trip Plan" />
                        </div>
                    </div>
                </div>

                <div className="mt-14 relative" data-testid="hero-collage">
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
                        <img src={IMAGES.heroGroup} alt="Group of friends enjoying a trip together" loading="eager" className="rounded-2xl object-cover h-40 sm:h-52 w-full border border-stone-300" />
                        <img src={IMAGES.mountains} alt="Group trekking in the Himalayas" loading="lazy" className="rounded-2xl object-cover h-40 sm:h-52 w-full border border-stone-300 md:mt-8" />
                        <img src={IMAGES.goa} alt="Beach escape in Goa" loading="lazy" className="rounded-2xl object-cover h-40 sm:h-52 w-full border border-stone-300" />
                        <img src={IMAGES.heroBus} alt="Tour bus on a group journey" loading="lazy" className="rounded-2xl object-cover h-40 sm:h-52 w-full border border-stone-300 md:mt-8" />
                    </div>
                    <div className="absolute -top-6 right-6 h-24 w-24 sm:h-28 sm:w-28 rounded-full bg-gold border-4 border-cream flex items-center justify-center text-center rotate-6 shadow-lg">
                        <span className="font-script text-navy text-lg sm:text-xl leading-tight font-bold">You bring<br />the people.<br />We create the<br />journey.</span>
                    </div>
                </div>
            </div>
        </section>
    );
}
